import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { InstituteId, VerityInstituteId } from "./institute.ts";
import apiClient from "../../../helpers/api-client";

export type CourseId = string & { __brand: "CourseId" };

export type AccessControlCourse = {
    id: CourseId;
    instituteId: InstituteId;
    lmsCourseId: string;
    name: string;
    code?: string;
};

export type VerityCourse = {
    instituteId: VerityInstituteId;
    accessControlUuid: CourseId;
    courseInfo: unknown;
};

export type CreateVerityCoursePayload = Omit<AccessControlCourse, "id" | "instituteId"> & {
    instituteId: VerityInstituteId;
    accessControlUuid: CourseId;
};

const courseApi = createApi({
    reducerPath: "course",
    baseQuery: async (arg, api, extraOptions) =>
        fetchBaseQuery({
            fetchFn: apiClient.fetch.bind(apiClient),
            baseUrl: "/api/",
        })(arg, api, extraOptions),
    tagTypes: ["Course"],
    endpoints: (builder) => ({
        createAccessControlCourse: builder.mutation<AccessControlCourse, Omit<AccessControlCourse, "id">>({
            query: (course) => ({
                url: "access-control/course",
                method: "POST",
                body: course
            }),
            invalidatesTags: (result) => result
                ? [{ type: "Course" as const, id: result.id }]
                : ["Course"],
        }),
        createVerityCourse: builder.mutation<VerityCourse, CreateVerityCoursePayload>({
            query: ({ instituteId, accessControlUuid, lmsCourseId, name, code }) => ({
                url: "verity/course",
                method: "POST",
                body: { instituteId, accessControlUuid, lmsProvidedCourseId: lmsCourseId, courseInfo: { name, code } },
            }),
        }),
    }),
});

export default courseApi;
